package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Stable
import androidx.compose.ui.text.TextStyle

@Stable
data class LogWeightControlStyle(
    val titleStyle: TextStyle? = null,
)
